import ReactQueryInteropReducer from 'src/queries/redux/reactQueryInterop.reducer'
import {
  RESET_DATA_STATE,
  ResetDataStateAction,
} from 'src/redux/actions/data.actions'
import AccountRevisionsReducer, {
  AccountRevisionsState,
  Actions as BudgetRevisionsActions,
  initialState as initialBudgetRevisionsState,
} from 'src/redux/reducers/data/accountRevisions.reducer'
import ContactsReducer, {
  Actions as ContactsActions,
  ContactsState,
  initialState as initialContactsState,
} from 'src/redux/reducers/data/contacts.reducer'
import CountrysReducer, {
  Actions as CountrysActions,
  CountrysState,
  initialState as initialCountrysState,
} from 'src/redux/reducers/data/countrys.reducer'
import CreditCardsReducer, {
  Actions as CreditCardsActions,
  CreditCardsState,
  initialState as initialCreditCardsState,
} from 'src/redux/reducers/data/creditCards.reducer'
import ExpensesReducer, {
  Actions as ExpensesActions,
  ExpensesState,
  initialState as initialExpensesState,
} from 'src/redux/reducers/data/expenses.reducer'
import InvitedToOrgReducer, {
  Actions as InvitedToOrgActions,
  initialState as initialInvitedToOrgState,
  InvitedToOrgState,
} from 'src/redux/reducers/data/invitedToOrg.reducer'
import IssuerIntegratorsReducer, {
  Actions as IssuerIntegratorsActions,
  initialState as initialIssuerIntegratorsState,
  IssuerIntegratorsState,
} from 'src/redux/reducers/data/issuerIntegrators.reducer'
import IssuersReducer, {
  Actions as IssuersActions,
  initialState as initialIssuersState,
  IssuersState,
} from 'src/redux/reducers/data/issuers.reducer'
import MccGroupsReducer, {
  Actions as MccGroupsActions,
  initialState as initialMccGroupsState,
  MccGroupsState,
} from 'src/redux/reducers/data/mccGroups.reducer'
import MembersReducer, {
  Actions as MembersActions,
  initialState as initialMembersState,
  MembersState,
} from 'src/redux/reducers/data/members.reducer'
import MonthlySpendReducer, {
  Actions as MonthlySpendActions,
  initialState as initialMonthlySpendState,
  MonthlySpendState,
} from 'src/redux/reducers/data/monthlySpend.reducer'
import NotificationSettingsReducer, {
  Actions as NotificationSettingsActions,
  initialState as initialNotificationSettingsState,
  NotificationSettingsState,
} from 'src/redux/reducers/data/notificationSettings.reducer'
import OrganizationsReducer, {
  Actions as OrganizationsActions,
  initialState as initialOrganizationsState,
  OrganizationsState,
} from 'src/redux/reducers/data/organizations.reducer'
import OrgIntegrationsReducer, {
  Actions as OrgIntegrationsActions,
  initialState as initialOrgIntegrationsState,
  OrgIntegrationsState,
} from 'src/redux/reducers/data/orgIntegrations.reducer'
import ReceiptAttachmentsReducer, {
  Actions as ReceiptAttachmentsActions,
  initialState as initialReceiptAttachmentsState,
  ReceiptAttachmentsState,
} from 'src/redux/reducers/data/receiptAttachments.reducer'
import ReportDownloadsReducer, {
  Actions as ReportDownloadsActions,
  initialState as initialReportDownloadsState,
  ReportDownloadsState,
} from 'src/redux/reducers/data/reportDownloads.reducer'
import StatisticsReducer, {
  Actions as StatisticsActions,
  initialState as initialStatisticsState,
  StatisticsState,
} from 'src/redux/reducers/data/statistics.reducer'
import TransactionsReducer, {
  Actions as TransactionsActions,
  initialState as initialTransactionsState,
  TransactionsState,
} from 'src/redux/reducers/data/transactions.reducer'
import UsersReducer, {
  Actions as UsersActions,
  initialState as initialUsersState,
  UsersState,
} from 'src/redux/reducers/data/users.reducer'
import UserSavedFiltersReducer, {
  Actions as UserSavedFiltersActions,
  initialState as initialUserSavedFiltersState,
  UserSavedFiltersState,
} from 'src/redux/reducers/data/userSavedFilterViews.reducer'
import VirtualCardPushTasksReducer, {
  Actions as VirtualCardPushTasksActions,
  initialState as initialVirtualCardPushTasksState,
  VirtualCardPushTasksState,
} from 'src/redux/reducers/data/virtualCardPushTasks.reducer'
import VirtualCardsReducer, {
  Actions as VirtualCardsActions,
  initialState as initialVirtualCardsState,
  VirtualCardsState,
} from 'src/redux/reducers/data/virtualCards.reducer'

export type DataState = {
  virtualCards: VirtualCardsState
  creditCards: CreditCardsState
  users: UsersState
  transactions: TransactionsState
  budgetRevisions: AccountRevisionsState
  receiptAttachments: ReceiptAttachmentsState
  mccGroups: MccGroupsState
  issuers: IssuersState
  countrys: CountrysState
  notificationSettings: NotificationSettingsState
  issuerIntegrators: IssuerIntegratorsState
  virtualCardPushTasks: VirtualCardPushTasksState
  reportDownloads: ReportDownloadsState
  statistics: StatisticsState
  contacts: ContactsState
  members: MembersState
  invitedToOrg: InvitedToOrgState
  organizations: OrganizationsState
  orgIntegrations: OrgIntegrationsState
  expenses: ExpensesState
  monthlySpend: MonthlySpendState
  userSavedFilters: UserSavedFiltersState
  reactQueryInterop: Record<string, never>
}

export const initialState: DataState = {
  virtualCards: initialVirtualCardsState,
  creditCards: initialCreditCardsState,
  users: initialUsersState,
  transactions: initialTransactionsState,
  budgetRevisions: initialBudgetRevisionsState,
  receiptAttachments: initialReceiptAttachmentsState,
  mccGroups: initialMccGroupsState,
  issuers: initialIssuersState,
  countrys: initialCountrysState,
  notificationSettings: initialNotificationSettingsState,
  issuerIntegrators: initialIssuerIntegratorsState,
  virtualCardPushTasks: initialVirtualCardPushTasksState,
  reportDownloads: initialReportDownloadsState,
  statistics: initialStatisticsState,
  contacts: initialContactsState,
  members: initialMembersState,
  invitedToOrg: initialInvitedToOrgState,
  organizations: initialOrganizationsState,
  orgIntegrations: initialOrgIntegrationsState,
  expenses: initialExpensesState,
  monthlySpend: initialMonthlySpendState,
  userSavedFilters: initialUserSavedFiltersState,
  reactQueryInterop: {},
}

export type Actions =
  | ResetDataStateAction
  | VirtualCardsActions
  | CreditCardsActions
  | UsersActions
  | TransactionsActions
  | BudgetRevisionsActions
  | ReceiptAttachmentsActions
  | MccGroupsActions
  | IssuersActions
  | CountrysActions
  | NotificationSettingsActions
  | IssuerIntegratorsActions
  | VirtualCardPushTasksActions
  | ReportDownloadsActions
  | StatisticsActions
  | ContactsActions
  | MembersActions
  | InvitedToOrgActions
  | OrganizationsActions
  | OrgIntegrationsActions
  | ExpensesActions
  | MonthlySpendActions
  | UserSavedFiltersActions

const DataReducer = (state = initialState, action: Actions): DataState =>
  action.type === RESET_DATA_STATE
    ? initialState
    : {
        virtualCards: VirtualCardsReducer(
          state.virtualCards,
          action as VirtualCardsActions,
        ),
        creditCards: CreditCardsReducer(
          state.creditCards,
          action as CreditCardsActions,
        ),
        users: UsersReducer(state.users, action as UsersActions),
        transactions: TransactionsReducer(
          state.transactions,
          action as TransactionsActions,
        ),
        budgetRevisions: AccountRevisionsReducer(
          state.budgetRevisions,
          action as BudgetRevisionsActions,
        ),
        receiptAttachments: ReceiptAttachmentsReducer(
          state.receiptAttachments,
          action as ReceiptAttachmentsActions,
        ),
        mccGroups: MccGroupsReducer(
          state.mccGroups,
          action as MccGroupsActions,
        ),
        issuers: IssuersReducer(state.issuers, action as IssuersActions),
        countrys: CountrysReducer(state.countrys, action as CountrysActions),
        notificationSettings: NotificationSettingsReducer(
          state.notificationSettings,
          action as NotificationSettingsActions,
        ),
        issuerIntegrators: IssuerIntegratorsReducer(
          state.issuerIntegrators,
          action as IssuerIntegratorsActions,
        ),
        virtualCardPushTasks: VirtualCardPushTasksReducer(
          state.virtualCardPushTasks,
          action as VirtualCardPushTasksActions,
        ),
        reportDownloads: ReportDownloadsReducer(
          state.reportDownloads,
          action as ReportDownloadsActions,
        ),
        statistics: StatisticsReducer(
          state.statistics,
          action as StatisticsActions,
        ),
        contacts: ContactsReducer(state.contacts, action as ContactsActions),
        members: MembersReducer(state.members, action as MembersActions),
        invitedToOrg: InvitedToOrgReducer(
          state.invitedToOrg,
          action as InvitedToOrgActions,
        ),
        organizations: OrganizationsReducer(
          state.organizations,
          action as OrganizationsActions,
        ),
        orgIntegrations: OrgIntegrationsReducer(
          state.orgIntegrations,
          action as OrgIntegrationsActions,
        ),
        expenses: ExpensesReducer(state.expenses, action as ExpensesActions),
        monthlySpend: MonthlySpendReducer(
          state.monthlySpend,
          action as MonthlySpendActions,
        ),
        userSavedFilters: UserSavedFiltersReducer(
          state.userSavedFilters,
          action as UserSavedFiltersActions,
        ),
        reactQueryInterop: ReactQueryInteropReducer({}, action),
      }

export default DataReducer
